import React from "react";
import { Database, RefreshCw } from "lucide-react";

/**
 * Small inline badge shown next to a result that was served from the offline
 * cache instead of a fresh network call.
 */
export default function OfflineBadge({ cachedAt, onRefresh, testId = "offline-badge" }) {
  if (!cachedAt) return null;
  const when = new Date(cachedAt).toLocaleString();
  return (
    <div
      data-testid={testId}
      className="inline-flex items-center gap-2 text-[11px] uppercase tracking-wider rounded-full bg-amber-500/10 border border-amber-500/25 text-amber-200 px-2.5 py-1"
    >
      <Database className="w-3 h-3" />
      Cached · {when}
      {onRefresh && (
        <button
          onClick={onRefresh}
          type="button"
          data-testid={`${testId}-refresh`}
          className="ml-1 hover:text-amber-100"
          aria-label="Refresh from server"
        >
          <RefreshCw className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}
